import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { useTranslation } from '../i18n';
import LanguageSelector from './LanguageSelector';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={closeMenu}>
          <span className="logo-icon">💆</span>
          <span className="logo-text">Thai Massage</span>
        </Link>

        <div className="header-right">
          <LanguageSelector />
          <button className="menu-toggle" onClick={toggleMenu} aria-label={t('menu_label')}>
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            {t('nav_home')}
          </Link>
          <Link
            to="/booking"
            className={`nav-link ${location.pathname === '/booking' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            {t('nav_booking')}
          </Link>
          <Link
            to="/therapists"
            className={`nav-link ${location.pathname === '/therapists' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            {t('nav_therapists')}
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
